'use client'

import { Button } from '@mantine/core'
import * as Sentry from '@sentry/nextjs'
import Link from 'next/link'
import { useEffect } from 'react'

// Error boundary for authenticated routes — renders inside the (main) layout
// so the navbar stays visible when a page crashes. Fatal errors in the root
// layout itself are handled by app/global-error.tsx.
export default function MainError({
  error
}: {
  error: Error & { digest?: string }
}) {
  // Segment boundaries stop propagation, so global-error's Sentry reporting
  // never sees these — report here.
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="flex h-full flex-col items-center justify-center bg-[#FAF6F2]">
      <div className="flex flex-col items-center text-center">
        <h1 className="font-heading text-5xl font-bold text-[var(--mantine-color-celerityBrand-9)]">
          Something went wrong
        </h1>
        <p className="mt-3 mb-6 text-lg text-[var(--mantine-color-celerityBrand-9)]">
          An unexpected error occurred. Please try again.
        </p>
        <Link href="/">
          <Button variant="filled">Back to Home</Button>
        </Link>
      </div>
    </div>
  )
}
